export interface EZKLProof {
  proof: string;
}

export interface EZKLVk {
  vk: { vkBytes: string };
}

export interface EZKLPubs {
  pubs: string[];
}
